export enum WebChannelSettingTypes {
  LOGO = 'logo',
  FAV_ICON = 'favIcon',
}
